"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebhookEndpointKind = exports.SUBSCRIBABLE_WEBHOOK_EVENT_TYPES = exports.WebhookEventType = void 0;
var WebhookEventType;
(function (WebhookEventType) {
    WebhookEventType["PaymentCompleted"] = "payment.completed";
    WebhookEventType["PaymentCreated"] = "payment.created";
    WebhookEventType["PaymentUpdated"] = "payment.updated";
    WebhookEventType["PaymentDeleted"] = "payment.deleted";
    WebhookEventType["ContactCreated"] = "contact.created";
    WebhookEventType["ContactUpdated"] = "contact.updated";
    WebhookEventType["ContactDeleted"] = "contact.deleted";
})(WebhookEventType || (exports.WebhookEventType = WebhookEventType = {}));
exports.SUBSCRIBABLE_WEBHOOK_EVENT_TYPES = Object.values(WebhookEventType);
var WebhookEndpointKind;
(function (WebhookEndpointKind) {
    WebhookEndpointKind["Default"] = "default";
    WebhookEndpointKind["Zapier"] = "zapier";
})(WebhookEndpointKind || (exports.WebhookEndpointKind = WebhookEndpointKind = {}));
